import { Translator } from '@itarget/shared'

export const useTranslation = () => ({
  empty: Translator({ transRef: 'translation.Nenhum resultado encontrado' }).props.children,
})
